import { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../UserDashboardHome/UserDashboardHome.css";
import localeText from "../../../../locale";
import { FilterMatchMode } from "primereact/api";

const NetworkTable = (props) => {
  const [users, setUsers] = useState([]);

  const filters2 = {
    node: { value: null, matchMode: FilterMatchMode.CONTAINS },
    nodeusername: { value: null, matchMode: FilterMatchMode.CONTAINS },
    country: { value: null, matchMode: FilterMatchMode.CONTAINS },
    plan: { value: null, matchMode: FilterMatchMode.CONTAINS },
    email: { value: null, matchMode: FilterMatchMode.CONTAINS },
  };

  useEffect(() => {
    let cancel = false;

    if (cancel) return;
    setUsers(props.users);

    return () => {
      cancel = true;
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <div className="card border-1 border-300">
        {props.plan !== "Customer" && props.plan !== "Seller" ? (
          <>
            {props.directs && (
              <>
                <h3 className="my-4">{localeText("directs")}</h3>
                <hr />
              </>
            )}
            {!props.directs && (
              <>
                <h3 className="my-4">{localeText("all")}</h3>
                <hr />
              </>
            )}

            <DataTable
              value={users}
              paginator
              className="p-datatable-customers"
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              currentPageReportTemplate={localeText("showingFirstToLast")}
              rows={10}
              rowsPerPageOptions={[10, 20, 50]}
              filters={filters2}
              filterDisplay="row"
              responsiveLayout="scroll"
            >
              <Column
                header={localeText("profilePic")}
                style={{ width: "10%" }}
                body={(rowData, i) => {
                  return (
                    <div
                      key={i.rowIndex}
                      style={{
                        background: `url(${rowData.urlavatar})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                      className="layout-dashboard-urlavatar"
                    ></div>
                  );
                }}
              ></Column>
              <Column
                sortable
                field="country"
                filter
                filterPlaceholder={localeText("searchByCountry")}
                filters={filters2}
                filterDisplay="row"
                header={localeText("country")}
                body={(user, i) => {
                  return (
                    <div className="flex align-items-center mr-8" key={i.rowIndex}>
                      <img
                        alt={user.country}
                        height={32}
                        src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${
                          user.country ? user.country : "US"
                        }.svg`}
                      />
                      <span className="text-sm mx-1">{user.country}</span>
                    </div>
                  );
                }}
                style={{ width: "14%" }}
              />
              <Column
                sortable
                field="nodeusername"
                header={localeText("username")}
                style={{ width: "15%" }}
                filter
                filterPlaceholder={localeText("searchByUsername")}
                filters={filters2}
                filterDisplay="row"
              />
              <Column
                sortable
                field="node"
                header={localeText("name")}
                style={{ width: "18%" }}
                filter
                filterPlaceholder={localeText("searchByName")}
                filters={filters2}
                filterDisplay="row"
              />
              <Column sortable field="level" header={localeText("level")} style={{ width: "8%" }} />
              <Column
                sortable
                field="email"
                header="Email"
                style={{ width: "20%" }}
                filter
                filterPlaceholder={localeText("searchByEmail")}
                filters={filters2}
                filterDisplay="row"
              />
              <Column
                sortable
                field="plan"
                header={localeText("plan")}
                style={{ width: "10%" }}
                filter
                filterPlaceholder={localeText("searchByPlan")}
                filters={filters2}
                filterDisplay="row"
                body={(rowData, i) => {
                  return (
                    <div key={i.rowIndex}>
                      {rowData.plan === "Customer" && (
                        <span
                          className="team-member-role text-0 p-1 border-round"
                          style={{ backgroundColor: "#2196F3" }}
                        >
                          {rowData.plan}
                        </span>
                      )}
                      {rowData.plan === "Partner" && (
                        <span
                          className="team-member-role text-0 p-1 border-round"
                          style={{ backgroundColor: "#4CAF50" }}
                        >
                          {rowData.plan}
                        </span>
                      )}
                      {rowData.plan === "Manager" && (
                        <span
                          className="team-member-role text-0 p-1 border-round"
                          style={{ backgroundColor: "#F7B005" }}
                        >
                          {rowData.plan}
                        </span>
                      )}
                      {rowData.plan === "Promoter" && (
                        <span
                          className="team-member-role text-0 p-1 border-round"
                          style={{ backgroundColor: "#9C27B0" }}
                        >
                          {rowData.plan}
                        </span>
                      )}
                      {rowData.plan?.toLowerCase() === "store" && (
                        <span
                          className="team-member-role text-0 p-1 border-round"
                          style={{ backgroundColor: "red" }}
                        >
                          {rowData.plan}
                        </span>
                      )}
                    </div>
                  );
                }}
              ></Column>
            </DataTable>
          </>
        ) : (
          <div className="text-center">
            <i className="pi pi-lock text-8xl text-400 my-4"></i>
            <h2 className="my-6">{localeText("planNotAllowed")}</h2>
          </div>
        )}
      </div>
    </div>
  );
};

export default NetworkTable;
